module.exports = __webpack_public_path__ + "static/media/bg_white_modified.ae9281f8.png";